import React from 'react';
import TeamPageLayout from '../components/TeamPageLayout';
import TeamActivityView from '../components/TeamActivityView';

/**
 * Activity tab only: layout (with shared tabs) + activity view.
 * Receives common data from parent; contains no settings or connector logic.
 */
function TeamActivityContainer({
  team = null,
  teamConnectorConfigurations = [],
  teamConnectorConfigurationsHasLoaded = false,
  goals = [],
  assessments = [],
  onSetPrimary = () => {},
  onToggleAssessmentLock = () => {},
  onDeleteAssessment = () => {},
  onCopyLink = () => {},
}) {
  return (
    <TeamPageLayout
      team={team}
      teamConnectorConfigurations={teamConnectorConfigurations}
      teamConnectorConfigurationsHasLoaded={
        teamConnectorConfigurationsHasLoaded
      }
    >
      <TeamActivityView
        team={team}
        goals={goals}
        assessments={assessments}
        onSetPrimary={onSetPrimary}
        onToggleAssessmentLock={onToggleAssessmentLock}
        onDeleteAssessment={onDeleteAssessment}
        onCopyLink={onCopyLink}
      />
    </TeamPageLayout>
  );
}

export default TeamActivityContainer;
